import { useEffect } from 'react';

export const useCustomEvent = (eventName: string, handler: (evt: Event) => void) => {
  useEffect(() => {
    document.addEventListener(eventName, handler);

    return () => {
      document.removeEventListener(eventName, handler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export const dispatchCustomEvent = (eventName: string, detail: unknown) => {
  document.dispatchEvent(new CustomEvent(eventName, { detail }));
};
